export default { sha: '48013d41be1bee941abf8598e7eea4bf0892d346', buildNumber: 'undefined' }
